import React, { useState, useEffect } from "react";
import { ArrowRight, Phone } from "lucide-react";
import { heroImages, contact } from "../mock";

export default function Hero() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroImages.length), 5000);
    return () => clearInterval(t);
  }, []);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="home" className="relative">
      <div className="relative h-[62vh] min-h-[420px] md:h-[80vh] md:min-h-[560px] w-full overflow-hidden">
        {heroImages.map((src, i) => (
          <img
            key={src}
            src={src}
            alt="Graduates celebrating"
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
              i === idx ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-t from-[#16244F]/85 via-[#16244F]/35 to-transparent" />

        <div className="relative z-10 h-full max-w-[1200px] mx-auto px-5 flex flex-col justify-end pb-12 md:pb-20">
          <div className="max-w-2xl">
            <span className="inline-block mb-4 px-4 py-1.5 rounded-full bg-[#F58220] text-white text-xs md:text-sm font-semibold font-head tracking-wide">
              SHAPE YOUR FUTURE
            </span>
            <h1 className="font-head text-white font-extrabold leading-tight text-3xl md:text-5xl drop-shadow">
              Guiding Students Toward the <span className="text-[#F9B57C]">Right Career</span>
            </h1>
            <p className="mt-4 text-white/90 text-base md:text-lg max-w-xl">
              Personalised career counselling, psychometric assessments and expert guidance for school, domestic and overseas education.
            </p>
            <div className="mt-7 flex flex-wrap gap-4">
              <button
                onClick={() => scrollTo("contact")}
                className="group inline-flex items-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold px-6 py-3.5 rounded-lg transition-colors"
              >
                Book an Appointment
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </button>
              <a
                href={`tel:${contact.phone.replace(/\s/g, "")}`}
                className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur text-white border border-white/40 font-head font-semibold px-6 py-3.5 rounded-lg transition-colors"
              >
                <Phone size={18} /> {contact.phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
